import React, { useState, useEffect } from "react";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import { SubHeader } from "components/SubHeader";
import { Icons } from "components/Icons";
import { Table } from "components/Table";
import { api } from "services/api";
import { Button } from "components/Button";

export function List(props) {
  const [customerName, setCustomerName] = useState("");
  const [pdfLoadingId, setPdfLoadingId] = useState(null);

  const handlePdf = async (item) => {
    if (pdfLoadingId) return;
    setPdfLoadingId(item._id);
    try {
      const { data } = await api.get(`/connect/reportbroiler/pdf/${item._id}`);
      if (data && data.url) {
        window.open(data.url, "_blank");
      } else {
        throw new Error("URL do PDF não retornada");
      }
    } catch (e) {
      Swal.fire(
        "Relatório",
        "Não foi possível gerar o PDF deste relatório. Tente novamente.",
        "error"
      );
    } finally {
      setPdfLoadingId(null);
    }
  };

  const editHandler = (item) => {
    try {
      // urls antigas podem vir sem barra inicial e/ou com "/<reportId>" (às
      // vezes "/undefined") depois do JSON — extrai só o trecho entre chaves
      const start = item.url.indexOf("{");
      const end = item.url.lastIndexOf("}");
      const query = JSON.parse(item.url.slice(start, end + 1));
      if (!Array.isArray(query.injuryType)) {
        query.injuryType = [query.injuryType];
      }
      props.history.push(
        `/customer/connect/broiler/report/${
          props.match.params.id
        }/${JSON.stringify(query)}/${item._id}`
      );
    } catch (e) {
      Swal.fire(
        "Editar Relatório",
        "Não foi possível abrir este relatório para edição.",
        "error"
      );
    }
  };

  const tableParams = [
    {
      key: "customer",
      params: "name",
      label: "Cliente",
      mobile: {
        type: "title",
      },
    },
    {
      key: "createdBy",
      params: "name",
      label: "Criado por",
      filter: "text",
      placeholder: "Nome",
      mobile: {
        type: "item",
      },
    },
    {
      key: "date",
      label: "Data",
      type: "date",
      filter: "date",
      mobile: {
        type: "small",
      },
    },
    {
      key: "reportId",
      label: "PDF",
      type: "custom",
      mobile: {
        type: "small",
      },
      response: (item) => (
        <Button
          bg="danger"
          color="white"
          border="danger"
          size="sm"
          onClick={() => handlePdf(item)}
          disabled={pdfLoadingId === item._id}
        >
          {pdfLoadingId === item._id ? (
            <ReactLoading
              type="spin"
              color="#fff"
              width={14}
              height={14}
            />
          ) : (
            <Icons type="download" size="14" color="#fff" />
          )}
        </Button>
      ),
    },
  ];

  useEffect(() => {
    const getCustomerName = async () => {
      const response = await api.get(
        `/connect/customer/${props.match.params.id}`
      );
      setCustomerName(response.data.name);
    };
    if (props.match.params.id) {
      getCustomerName();
    }
  }, [props.match.params.id]);

  return (
    <>
      <SubHeader
        {...props}
        title={customerName}
        route="reportbroiler"
        breadcrumbs={[
          {
            label: customerName,
            to: "/connect/customer/" + props.match.params.id,
          },
          {
            label: "Frango de corte",
          },
          {
            label: "Relatórios",
          },
        ]}
        icon={<Icons type="lineChart" size="24" color="#fff" />}
      />
      <Table
        cols={tableParams}
        editHandler={editHandler}
        emptyText={"Nenhuma relatório localizada!"}
        route={`/connect/reportbroiler`}
        {...props}
      />
    </>
  );
}
